import { IonContent, IonIcon, IonLabel, IonList, IonPage } from '@ionic/react';
import { UserIcon } from '@phosphor-icons/react';
import React from 'react';

import { logOutOutline } from 'ionicons/icons';

import Alert from '../../components/UI/Alert';
import Button from '../../components/UI/Button';
import Modal from '../../components/UI/Modal';
import Navigation from '../../components/UI/Navigation';
import UserMenuSection from '../../components/UI/UserMenuSection';
import { useUserPage } from '../../hooks/Helpers/useUserPage';
import './UserPage.scss';

const UserPage: React.FC = () => {
  const { userInfo, appVersion, menu, modal, alert, goBack, showLogoutAlert } =
    useUserPage();

  return (
    <IonPage>
      <Navigation onBack={goBack} />

      <IonContent className="user-page">
        <div className="user-page__userContainer">
          {userInfo.isLoaded ? (
            <>
              <UserIcon size={90} weight="fill" />
              <IonLabel className="user-page__userContainer--name">
                {userInfo.name}
              </IonLabel>
              <IonLabel className="user-page__userContainer--email">
                {userInfo.email}
              </IonLabel>
            </>
          ) : (
            <>
              <UserIcon size={90} />
              <IonLabel className="user-page__userContainer--no_user">
                No hay datos de usuario
              </IonLabel>
            </>
          )}
        </div>

        <div className="ion-padding-horizontal">
          <IonList lines="none">
            <UserMenuSection title="Cuenta" items={menu.cuentaItems} />
            <UserMenuSection title="Soporte" items={menu.soporteItems} />
          </IonList>

          <div className="ion-padding-bottom">
            <Button marginBottom={false} color="dark" onClick={showLogoutAlert}>
              <IonIcon icon={logOutOutline} className="aux-margin" />
              Cerrar sesión
            </Button>
          </div>

          <span className="user-page__version">V {appVersion}</span>
        </div>

        <Modal isOpen={modal.isOpen} onClose={modal.closeModal} {...modal}>
          {modal.content}
        </Modal>

        <Alert
          isOpen={alert.isOpen}
          header={alert.header}
          message={alert.message}
          buttons={alert.buttons}
          onDidDismiss={alert.hideAlert}
        />
      </IonContent>
    </IonPage>
  );
};

export default UserPage;
